import { getAccessToken } from "./token.service";

export default function authHeader() {
  let user = getAccessToken();

  if (user) {
    return { 
      Authorization: 'Bearer ' + user,
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    };
  } else {
    return {};
  }
}
